module.exports = __webpack_public_path__ + "media/images/circle-yes-7e48323d4a81c1ef3eb3777c9cc18322.svg";